var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBedroom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 16,
    viewBox: "0 0 19 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 1V14.8M1 11.8429H18.7429M18.7429 14.8V9.08286C18.7429 7.97876 18.7429 7.42666 18.528 7.00497C18.339 6.63405 18.0374 6.33242 17.6665 6.14346C17.2448 5.92857 16.6927 5.92857 15.5886 5.92857H8.88572V11.5741M4.94286 7.9H4.95271M5.92857 7.9C5.92857 8.44441 5.48725 8.88571 4.94286 8.88571C4.39847 8.88571 3.95714 8.44441 3.95714 7.9C3.95714 7.35559 4.39847 6.91429 4.94286 6.91429C5.48725 6.91429 5.92857 7.35559 5.92857 7.9Z",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBedroom);
export default __webpack_public_path__ + "static/media/bedroom.f066331cd8da8ec1c0f5fc08193d0bf9.svg";
export { ForwardRef as ReactComponent };